import { Box, Flex, Link, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import { LeftIcon } from '~/components/icons';
import { useBreakpointValue } from '~/utils-ts';

interface Props {
  href: string;
}

export const GoBack: React.FC<Props> = ({ href }) => {
  const isDesktop = useBreakpointValue({ base: false, md: true });

  return (
    <Box>
      <NextLink href={href} passHref legacyBehavior>
        <Link>
          {isDesktop ? (
            <Flex alignItems="center" cursor="pointer">
              <LeftIcon color="primary.500" />
              <Box display={{ base: 'none', md: 'inline' }}>
                <Text fontSize="sm" fontWeight="medium">
                  All Media Packs
                </Text>
              </Box>
            </Flex>
          ) : (
            <LeftIcon color="primary.500" />
          )}
        </Link>
      </NextLink>
    </Box>
  );
};
